import { FunctionComponent, memo, useContext } from "react";
import { IProps } from "./custom-reports-list.types";
import urljoin from "url-join";
import { Link } from "react-router-dom";
import Page from "constants/page";
import useMetabaseDashboards from "hooks-for/custom-reports/use-metabase-dashboards";
import { IMetabaseDashboard } from "@edgetier/watchtower-types";
import { SpinnerUntil } from "@edgetier/components";
import { SidebarContext } from "@edgetier/sidebar";
import "./custom-reports-list.scss";

/**
 * A list of the reports that the user can view.
 */
const CustomReportsList: FunctionComponent<IProps> = () => {
    const { data: dashboards } = useMetabaseDashboards();
    const { hideSidebar } = useContext(SidebarContext);
    return (
        <SpinnerUntil<IMetabaseDashboard[]> data={dashboards} isReady={typeof dashboards !== "undefined"}>
            {(data) => (
                <ul className="custom-reports-list">
                    {data.map(({ metabaseDashboardId, dashboardTitle }) => (
                        <Link
                            key={metabaseDashboardId}
                            className="custom-reports-list__list-item"
                            onClick={() => hideSidebar()}
                            to={urljoin(Page.CustomReports, metabaseDashboardId.toString())}
                        >
                            <li>{dashboardTitle}</li>
                        </Link>
                    ))}
                </ul>
            )}
        </SpinnerUntil>
    );
};

export default memo(CustomReportsList);
